<template>
     <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '展后新闻报道')[0].value">
        <div  style="margin-top: 3%;width: 90%;">
          <div>
            <div style="text-align: center;margin-bottom: 10px;">
              <h3>{{ NewsCoverageform.name }}</h3>
            </div>
            <div style="margin-bottom: 10px;">
              <span>{{ NewsCoverageform.describe }}</span>
            </div>
            <div>
              <el-form :model="NewsCoverageForm"
                      ref="NewsCoverageForm"
                      :rules="rules"
                >
                <el-form-item>
                  <el-button type="primary" v-if="SModelNewsCoverageList.filter( (t) =>t.state != Global.SModel.Delete && t.newsCoverageID==NewsCoverageform.id).length == 0"
                            @click="onsubmit()">{{SModelNewsCoverageList.filter( (t) =>t.state != Global.SModel.Delete && t.newsCoverageID==NewsCoverageform.id).length > 0
                                                                              ? "取消"
                                                                              : "发布"
                                                                          }}</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </ShowControl>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import ShowControl from "../../UserControl/ShowControl.vue"
  export default {
    components: {
    ShowControl
  },
    data () {
      return {
        flowID: localStorage.getItem("flowID"),
        caseID: localStorage.getItem("caseId"),
        AllNewsCoverage: [],
        NewsCoverageview: false,
        SModelNewsCoverageList: [],
        NewsCoverageform: {},
        isdisabled: false,
        NewsCoverageForm: {},
        title: '展后新闻报道',
      }
    },
    computed: {
      ...mapState({
        Round: (state) => state.user.round,
        ChatShow:(state) => state.user.chatShows,
      }),
    },
    mounted () {
     this.GetNewsCoverages()
     this.$refs.showControl.receiveValue(true);
    },
    methods: {
      revertClick(){
      this.$router.push("/NewsCoverageCard")
    },
      GetNewsCoverages(){
      this.$http.get('NewsCoverage/GetModels?id='+this.$route.query.id).then((res) => {
            if (res.success) {
              this.NewsCoverageform = res.dynamicObj
              this.GetSModelNewsCoverage();
            } else {
              this.$message.warning(res.message)
            }
          })
      },
      GetSModelNewsCoverage () {
        this.$http
          .get(
            "SModel/GetTypeSModel?round=" +
            this.Round +
            "&typename=S_NewsCoverage"
          )
          .then((res) => {
            if (res.success) {
              this.SModelNewsCoverageList = res.dynamicObj;
              if (this.SModelNewsCoverageList.filter(c => c.state != this.Global.SModel.Delete && c.newsCoverageID == this.NewsCoverageform.id).length > 0) {
                this.isdisabled = true;
                this.NewsCoverageForm = this.SModelNewsCoverageList.filter(c => c.state != this.Global.SModel.Delete && c.newsCoverageID == this.NewsCoverageform.id)[0];
              } else {
                this.isdisabled = false;
              }
            } else {
              return this.$message.error(res.message);
            }
          });
      },
      onsubmit () {
        if (this.flowID != this.Global.FlowList.反馈) {
          this.$message.error("当前流程阶段不是反馈，无法进行操作！");
          return;
        }
        let that = this;
        that.$refs.NewsCoverageForm.validate((valid) => {
          if (valid) {
            let list = that.SModelNewsCoverageList.filter(c => c.newsCoverageID == this.NewsCoverageform.id);
            //var cost=this.NewsCoverageform.cost * this.NewsCoverageform.number;
            if (list.filter(c => c.state != that.Global.SModel.Delete).length > 0) {
              list[0].state = that.Global.SModel.Delete;
              that.$http
                .post("SModel/PushStrategy", that.Global.getsmodel(list))
                .then((res) => {
                  if (res.success) {
                    //this.Global.GetBudget(-cost);
                    that.Global.sendmsgmd(
                      "会展营销",
                      `取消了${this.NewsCoverageform.name}展后新闻报道`,
                      1
                    );
                    that.GetSModelNewsCoverage();
                    this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.delete,'展后新闻报道');
                  } else {
                    that.$message.error(res.message);
                    return false;
                  }
                });
            } else {
              if (list.length == 0) {
                list = [];
                list.push(that.NewsCoverageForm)
                list[0].uuid = that.uuid.guid();
                list[0].state = that.Global.SModel.Create;
              } else {
                let uuid = list[0].uuid;
                list = [];
                list.push(that.NewsCoverageForm)
                list[0].state = that.Global.SModel.Update;
                list[0].uuid = uuid;
              }
              list[0].round = that.Round;
              list[0].type = "S_NewsCoverage";
              list[0].sTTime = that.filter.formatDate(new Date());
              list[0].newsCoverageID = that.NewsCoverageform.id;
  
              //list[0].cost=cost;
              that.$http
                .post("SModel/PushStrategy", that.Global.getsmodel(list))
                .then((res) => {
                  if (res.success) {
                    that.Global.sendmsgmd(
                      "会展营销",
                      `操作了${this.NewsCoverageform.name}展后新闻报道`,
                      1
                    );
                    that.GetSModelNewsCoverage();
                    this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.展后新闻报道 });  
                    this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.normal,'展后新闻报道');
                  } else {
                    that.$message.error(res.message);
                    return false;
                  }
                });
            }
  
          }
        });
  
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  .mediaitem {
    width: 20%;
    height: 18%;
    border-radius: 10%;
    overflow: hidden;
    margin: 5px 15px;
    // background-color: rgb(230, 98, 98);
    transform: scale(1);
    transition: all 0.6s;
    display: inline-block;
  }
  .mediaitem:hover {
    transform: scale(1.2);
  }
  .hand {
    cursor: pointer;
    width: 100%;
    height: 100%;
  }
  </style>